import { CACHE_TIMES } from '@/config/cache';
import type { DateRange, SelectedNetwork, ShowFilter } from '@/types';
import { useCampaignsQuery } from '@/services/revenueApi';

/**
 * This hook is used to fetch the campaign data.
 * @param selectedNetwork - The selected network.
 * @param modalDateRange - The date range.
 * @param enabled - Whether to fetch the data or not.
 * @returns The campaign data.
 */
const useCampaignData = (
  selectedNetwork: SelectedNetwork | undefined,
  modalDateRange: DateRange,
  enabled: boolean,
  modalSelectedShow?: ShowFilter
) => {
  return useCampaignsQuery(
    selectedNetwork?.id ?? '',
    modalDateRange.from,
    modalDateRange.to,
    {
      enabled,
      refetchOnMount: false,
      staleTime: CACHE_TIMES.SHORT,
    },
    {
      showIds: modalSelectedShow !== 'all' && modalSelectedShow ? [modalSelectedShow] : undefined,
    }
  );
};

export default useCampaignData;
